import * as styles from "@clientFrontend/features/scout/components/UserTable/styles.css";
import { LIST_MAX_LENGTH } from "@clientFrontend/features/scout/components/UserTable/constants";

export type ListCellProps = {
  items: string[];
  ariaLabel: string;
};

export const ListCell = ({ items, ariaLabel }: ListCellProps) => (
  <td className={`${styles.td} ${styles.userDetailTd}`} aria-label={ariaLabel}>
    {items.slice(0, LIST_MAX_LENGTH).map((item, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <p key={index}>{item}</p>
    ))}
    {items.length > LIST_MAX_LENGTH && <p> など</p>}
  </td>
);
